module.exports = __webpack_public_path__ + "static/media/Drop.2b5062d7.svg";